<template>
  <b-container fluid>
    <b-row>
      <b-col class="top_bar" :style="{ background: course.color }"></b-col>
    </b-row>
    <b-row
      ><b-col><div class="page_title">Session Reports</div></b-col></b-row
    >
    <b-row class="padding mb-3" v-if="isStaff">
      <b-col>
        <b-button class="tsny_button" @click="openCreateSessionReportModal"
          >+ Create Report</b-button
        >
      </b-col>
    </b-row>
    <b-row class="padding mb-3">
      <b-col> <next-session-bar :course="course"/></b-col>
    </b-row>
    <b-row
      class="page_indentation"
      v-for="(sessionReport, index) in sessionReports"
      :key="sessionReport._id"
    >
      <session-report
        class="mb-3"
        :session="sessionReport"
        @update-report="updateSessionReportHandler(index)"
        @delete-report="deleteSessionReportHandler(index)"
      />
    </b-row>
    <create-session-report-modal :id="id" />
    <update-session-report-modal
      :id="id"
      :report="sessionReports[selectedIndex]"
    />
    <delete-session-report-modal
      :id="id"
      :report="sessionReports[selectedIndex]"
    />
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import StoreConstants from "../../store/services/StoreConstants";
import SessionReport from "../../components/SessionReports/SessionReport";
import CreateSessionReportModal from "../../components/SessionReports/CreateSessionReportModal";
import DeleteSessionReportModal from "../../components/SessionReports/DeleteSessionReportModal";
import NextSessionBar from "../../components/Course/NextSessionBar";
import Constants from "../../services/Constants";
import UpdateSessionReportModal from "../../components/SessionReports/UpdateSessionReportModal";

export default {
  name: "SessionReports",
  components: {
    UpdateSessionReportModal,
    NextSessionBar,
    CreateSessionReportModal,
    DeleteSessionReportModal,
    SessionReport
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseGetter: StoreConstants.GETTERS.COURSE,
      isStaff: StoreConstants.GETTERS.IS_STAFF
    }),
    course: function() {
      return this.courseGetter(this.id);
    },
    sessionReports: function() {
      return this.course.sessionReports.length
        ? this.course.sessionReports
        : [
            {
              report: Constants.SESSION_REPORTS.REPORT_PLACEHOLDER,
              assignment: Constants.SESSION_REPORTS.ASSIGNMENT_PLACEHOLDER
            }
          ];
    }
  },
  data: function() {
    return { selectedIndex: null };
  },
  methods: {
    openCreateSessionReportModal: function() {
      this.$bvModal.show("createSessionReportModal");
    },
    updateSessionReportHandler: function(index) {
      this.selectedIndex = index;
      this.$bvModal.show("updateSessionReportModal");
    },
    deleteSessionReportHandler: function(index) {
      this.selectedIndex = index;
      this.$bvModal.show("deleteSessionReportModal");
    }
  }
};
</script>

<style scoped>
.padding {
  padding-left: 45px;
  padding-right: 45px;
}
</style>
